import UsersRepository from 'client-sdk/src/Repository/users-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_CENTERS_WITH_ID_FAILED,
  GET_CENTERS_WITH_ID_SUCCESS,
  GET_CENTERS_WITH_ID,
  GET_CENTERS_FAILED,
  GET_CENTERS_SUCCESS,
  GET_CENTERS,
  UPDATE_CENTERS_FAILED,
  UPDATE_CENTERS_SUCCESS,
  UPDATE_CENTERS,
  CREATE_CENTERS_FAILED,
  CREATE_CENTERS_SUCCESS,
  CREATE_CENTERS,
  GET_USERS_BY_CENTERS_ID_SUCCESS,
  GET_USERS_BY_CENTERS_ID_FAILED,
  GET_USERS_BY_CENTERS_ID,
  GET_USERS_BE_ADMIN_CENTER,
  GET_USERS_BE_ADMIN_CENTER_SUCCESS,
  GET_USERS_BE_ADMIN_CENTER_FAILED,
  UPDATE_CENTER_ADMIN,
  UPDATE_CENTER_ADMIN_SUCCESS,
  UPDATE_CENTER_ADMIN_FAILED,
  GET_ALL_CENTERS_REPORT,
  GET_ALL_CENTERS_REPORT_SUCCESS,
  GET_ALL_CENTERS_REPORT_FAILED,
  GET_ALL_SUPERVISORS,
  GET_ALL_SUPERVISORS_SUCCESS,
  GET_ALL_SUPERVISORS_FAILED,
  UPDATE_CENTER_STATUS,
  UPDATE_CENTER_STATUS_SUCCESS,
  UPDATE_CENTER_STATUS_FAILED,
  GET_CENTERS_ACTIVE_COUNT,
  GET_CENTERS_ACTIVE_COUNT_SUCCESS,
  GET_CENTERS_ACTIVE_COUNT_FAILED,
  GET_CENTERS_DEACTIVE_COUNT,
  GET_CENTERS_DEACTIVE_COUNT_SUCCESS,
  GET_CENTERS_DEACTIVE_COUNT_FAILED,
  GET_CENTERS_STATISTICS,
  GET_CENTERS_STATISTICS_SUCCESS,
  GET_CENTERS_STATISTICS_FAILED,
  GET_CENTERS_STATISTICS_WITH_ID,
  GET_CENTERS_STATISTICS_WITH_ID_SUCCESS,
  GET_CENTERS_STATISTICS_WITH_ID_FAILED,
} from './constants';

import {GetAllAgenciesRequestBuilder} from 'client-sdk/src/supervisors/supervisors';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotfication';
import CentersRepository from 'client-sdk/src/Repository/centers-repository';

const token = localStorage.getItem('token') || '';
export function* getCenters(actions: any): unknown {
  try {
    const {response, count} = yield CentersRepository.getCenters(actions);
    yield put({
      type: GET_CENTERS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_CENTERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getUsersByCenterId(actions: any): unknown {
  try {
    const response = yield UsersRepository.getUsersByCenterId(actions);
    yield put({
      type: GET_USERS_BY_CENTERS_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_BY_CENTERS_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getUsersBeAdminCenter(actions: any): unknown {
  try {
    const response = yield UsersRepository.getUsersBeAdminCenter(actions);

    yield put({
      type: GET_USERS_BE_ADMIN_CENTER_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_BE_ADMIN_CENTER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCentersWithId(actions: any): unknown {
  try {
    const response = yield CentersRepository.getCentersWithId(actions);
    yield put({
      type: GET_CENTERS_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_CENTERS_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateCenter(actions: any): unknown {
  const {body, pagination, id} = actions.payload;
  try {
    yield CentersRepository.updateCenter(actions);
    yield put({
      type: UPDATE_CENTERS_SUCCESS,
    });
    yield put({
      type: GET_CENTERS,
      payload: {
        ...pagination,
        partnerId: {equals: id || null},
      },
    });
  } catch (error) {
    yield put({
      type: UPDATE_CENTERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createCenter(actions: any): unknown {
  const {pagination, id, callback} = actions.payload;
  try {
    yield CentersRepository.createCenter(actions);
    yield put({
      type: CREATE_CENTERS_SUCCESS,
    });
    yield put({
      type: GET_CENTERS,
      payload: {...pagination, partnerId: {equals: id}},
    });

    callback && callback();

    handleNotfication('مرکز با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_CENTERS_FAILED,
      error: error.message,
    });
    handleNotfication('اضافه کردن مرکز با خطا مواجه شد', 'error');
    // handleError(error.response);
  }
}

export function* updateCenterAdmin(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield CentersRepository.updateCenterAdmin(actions);
    yield put({
      type: UPDATE_CENTER_ADMIN_SUCCESS,
    });
    yield put({
      type: GET_USERS_BY_CENTERS_ID,
      payload: {...pagination},
    });
    handleNotfication('کاربر مرکز با موفقیت ویرایش شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_CENTER_ADMIN_FAILED,
      error: error.message,
    });
    handleError(error.response);
    handleNotfication('ویرایش کاربر مرکز با خطا مواجه شد', 'error');
  }
}

export function* getAllCentersReport(actions: any): unknown {
  try {
    const response = yield CentersRepository.getAllCentersReport(actions);
    yield put({
      type: GET_ALL_CENTERS_REPORT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_CENTERS_REPORT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getSupervisors(actions: any): unknown {
  try {
    const makeRequest = new GetAllAgenciesRequestBuilder()
      .params(flattenObject({...actions.payload, size: 100}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);

    yield put({
      type: GET_ALL_SUPERVISORS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_SUPERVISORS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateCenterStatus(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield CentersRepository.updateCenterStatus(actions);
    yield put({
      type: UPDATE_CENTER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_CENTERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_CENTER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCentersActiveCount(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    const count = yield CentersRepository.getCentersActiveCount(actions);

    yield put({
      type: GET_CENTERS_ACTIVE_COUNT_SUCCESS,
      count: count.data,
    });
    yield callback(count.data);
  } catch (error) {
    yield put({
      type: GET_CENTERS_ACTIVE_COUNT_FAILED,
      error: error.message,
    });
  }
}

export function* getCentersDeactiveCount(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    const count = yield CentersRepository.getCentersDeactiveCount(actions);

    yield put({
      type: GET_CENTERS_DEACTIVE_COUNT_SUCCESS,
      count: count.data,
    });
    yield callback(count.data);
  } catch (error) {
    yield put({
      type: GET_CENTERS_DEACTIVE_COUNT_FAILED,
      error: error.message,
    });
  }
}

export function* getCenterStatistics(actions: any): unknown {
  try {
    const response = yield CentersRepository.getCenterStatistics(actions);

    yield put({
      type: GET_CENTERS_STATISTICS_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_CENTERS_STATISTICS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCenterStatisticWithId(actions: any): unknown {
  try {
    const response = yield CentersRepository.getCenterStatisticWithId(actions);
    yield put({
      type: GET_CENTERS_STATISTICS_WITH_ID_SUCCESS,
      data: response.data.content,
    });
  } catch (error) {
    yield put({
      type: GET_CENTERS_STATISTICS_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* centerSaga() {
  yield takeLatest(GET_CENTERS, getCenters);
  yield takeLatest(GET_ALL_CENTERS_REPORT, getAllCentersReport);
  yield takeLatest(GET_CENTERS_WITH_ID, getCentersWithId);
  yield takeLatest(UPDATE_CENTERS, updateCenter);
  yield takeLatest(CREATE_CENTERS, createCenter);
  yield takeLatest(GET_USERS_BE_ADMIN_CENTER, getUsersBeAdminCenter);
  yield takeLatest(UPDATE_CENTER_ADMIN, updateCenterAdmin);
  yield takeLatest(GET_USERS_BY_CENTERS_ID, getUsersByCenterId);
  yield takeLatest(GET_ALL_SUPERVISORS, getSupervisors);
  yield takeLatest(UPDATE_CENTER_STATUS, updateCenterStatus);
  yield takeLatest(GET_CENTERS_ACTIVE_COUNT, getCentersActiveCount);
  yield takeLatest(GET_CENTERS_DEACTIVE_COUNT, getCentersDeactiveCount);
  yield takeLatest(GET_CENTERS_STATISTICS, getCenterStatistics);
  yield takeLatest(GET_CENTERS_STATISTICS_WITH_ID, getCenterStatisticWithId);
}
